import { render, staticRenderFns } from "./WxUserSource.vue?vue&type=template&id=52d63171&scoped=true"
import script from "./WxUserSource.vue?vue&type=script&lang=js"
export * from "./WxUserSource.vue?vue&type=script&lang=js"
import style0 from "./WxUserSource.vue?vue&type=style&index=0&id=52d63171&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d63171",
  null
  
)

export default component.exports